import React from 'react'
import { LocaleContext } from '@cbgms/base/locale/LocaleContext'

export interface CurrencyData {
  [key: string]: { countryName: string; currency: string; symbol: string }
}

export interface ICurrencyProps {
  amount?: string | number | undefined
  children?: (formattedAmount: string) => JSX.Element | string
  'data-testid'?: string
}

const Currency: React.FC<ICurrencyProps> = ({ amount, children, 'data-testid': dataTestID }) => {
  const { formatter } = React.useContext(LocaleContext)

  const formattedAmount = formatter.format(typeof amount === 'number' ? amount : parseFloat(amount || '0'))

  return (
    <span data-testid={dataTestID} style={{ whiteSpace: 'nowrap' }}>
      {children ? children(formattedAmount) : formattedAmount}
    </span>
  )
}

Currency.displayName = 'Currency'

export default React.memo(Currency)
